/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import colors from '@sportninja/common/constants/appColors'
import type { CalendarSubView, CalendarSubViewToggleProps } from './types'

const tabs: { value: CalendarSubView; label: string }[] = [
  { value: 'month', label: 'Month' },
  { value: 'week', label: 'Week' },
  { value: 'agenda', label: 'Agenda' },
]

const containerStyles = css`
  display: flex;
  align-items: center;
  gap: 0px;
  background-color: transparent;
  border: 1px solid ${colors.SECONDARY_200};
  border-radius: 8px;
  height: 40px;
  max-width: 300px;
`

const CalendarSubViewToggle = ({
  subView,
  onSubViewChange,
  disabled = false,
}: CalendarSubViewToggleProps) => {
  'use memo'

  return (
    <div
      css={css`
        ${containerStyles};
        opacity: ${disabled ? 0.5 : 1};
        transition: opacity 0.2s ease;
      `}
    >
      {tabs.map((tab, index) => {
        const isActive = subView === tab.value
        const isFirst = index === 0
        const isLast = index === tabs.length - 1

        return (
          <button
            key={tab.value}
            type='button'
            disabled={disabled}
            onClick={() => !disabled && onSubViewChange(tab.value)}
            css={css`
              display: flex;
              align-items: center;
              justify-content: center;
              width: 98px;
              height: 40px;
              border-radius: ${isFirst
                ? '8px 0 0 8px'
                : isLast
                ? '0 8px 8px 0'
                : '0'};
              background-color: ${isActive
                ? colors.SECONDARY_300
                : 'transparent'};
              border: none;
              cursor: ${disabled ? 'not-allowed' : 'pointer'};
              transition: all 0.2s ease;
              font-size: 14px;
              font-weight: ${isActive ? 700 : 400};
              line-height: 20.3px;
              color: ${colors.NEUTRAL_0};

              ${!disabled &&
              css`
                &:hover {
                  background-color: ${isActive
                    ? colors.SECONDARY_300
                    : colors.SECONDARY_200};
                }
                &:active {
                  transform: scale(0.98);
                }
              `}
            `}
          >
            {tab.label}
          </button>
        )
      })}
    </div>
  )
}

export default CalendarSubViewToggle
